/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnforcementStateEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type FreemiumStatusCallout_org = {
    readonly id: string;
    readonly orgAccountingPeriod: {
        readonly __typename: "OrgAccountingPeriod";
        readonly periodRange: {
            readonly minDate: string;
            readonly maxDate: string;
        };
        readonly quotaMax: number;
        readonly quotaUsed: number;
        readonly enforcementState: EnforcementStateEnum;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly featureGrid: {
        readonly __typename: "FeatureGrid";
        readonly stateMetadata: {
            readonly primaryBillingGroupMetadata: {
                readonly subscription: {
                    readonly id: string;
                };
            } | null;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "FreemiumStatusCallout_org";
};
export type FreemiumStatusCallout_org$data = FreemiumStatusCallout_org;
export type FreemiumStatusCallout_org$key = {
    readonly " $data"?: FreemiumStatusCallout_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FreemiumStatusCallout_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "FreemiumStatusCallout_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgAccountingPeriod",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DateRange",
                                "kind": "LinkedField",
                                "name": "periodRange",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minDate",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxDate",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaMax",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaUsed",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enforcementState",
                                "storageKey": null
                            }
                        ],
                        "type": "OrgAccountingPeriod",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v2 /*: any*/),
                            (v3 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "featureGrid",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentStateMetadata",
                                "kind": "LinkedField",
                                "name": "stateMetadata",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PrimaryBillingGroupMetadata",
                                        "kind": "LinkedField",
                                        "name": "primaryBillingGroupMetadata",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "PaymentSubscription",
                                                "kind": "LinkedField",
                                                "name": "subscription",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "FeatureGrid",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v3 /*: any*/),
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'fda538e0bfdb8c01897261e8effa48db';
export default node;
